import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

import { BreakPoints as BPs } from '@/app-constants';
import People from '@/content/people-index';

Vue.use(Vuex);

export default new Vuex.Store({

  state: {
    scrollState: {},
    scrollDirection: '',
    // device: 'mobile', // mobile, tablet, desktop

    // current width / height of window, dynamically updated
    width: 0,
    height: 0,

    people: People,
    workArticles: {
      // key'd on article slug
    },
  },

  getters: {

    isDesktop(state, getters) {
      return (getters.deviceType === BPs.desktop.key);
    },

    isMobile(state, getters) {
      return (getters.deviceType === BPs.mobile.key);
    },

    isTablet(state, getters) {
      return (getters.deviceType === BPs.tablet.key);
    },

    deviceType(state) {
      const width = state.width;
      let device = '';
      if (width >= BPs.desktop.size) {
        device = BPs.desktop.key;
      } else if (width >= BPs.tablet.size) {
        device = BPs.tablet.key;
      } else {
        device = BPs.mobile.key;
      }
      return device;
    },

    getPersonInfo(state) {
      return key => state.people[key] || null;
    },

    getWorkArticleBySlug(state) {
      return slug => state.workArticles[slug] || null;
    },

  },

  mutations: {

    saveWorkArticleData(state, payload) {
      const { workArticles } = state;
      const { slug } = payload;
      Vue.set(workArticles, slug, payload);
    },

    updateScrollState(state, payload) {
      const s = state;
      s.scrollState = payload;
    },

    updateScrollDirection(state, newState) {
      const s = state;
      s.scrollDirection = newState;
    },

    /*
      payload:
      {
        width: 0,
        height: 0,
      }
    */
    updateWindowDimensions(state, payload) {
      const { width, height } = payload;
      const s = state;
      s.width = width;
      s.height = height;
    },

  },

  actions: {

    loadWorkArticleData({ commit }, payload) {
      const { url } = payload;
      return axios({ method: 'get', url })
        .then((response) => {
          const { status, data } = response;
          if (status === 200) {
            return data;
          }
          throw new Error('something happened');
        })
        .then((data) => {
          commit('saveWorkArticleData', data);
        });
    },

  },
});



// WEBPACK FOOTER //
// ./src/data/store.js